import { render, staticRenderFns } from "./UpdateParentChildrenDialog.vue?vue&type=template&id=6bc70cfb"
import script from "./UpdateParentChildrenDialog.vue?vue&type=script&lang=js"
export * from "./UpdateParentChildrenDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports